import { Icon, Link, Tooltip } from "@shopify/polaris";
import { CircleInformationMajorFilled } from "@shopify/polaris-icons";
import React from "react";
import { CsI18n } from "../shared/csI18n/csI18n";

const TooltipHelper = {
  // todo: migrate t lightT()
  light: (description) => {
    return (
      <Tooltip light content={description}>
        <Link>
          <Icon source={CircleInformationMajorFilled} color="inkLighter" />
        </Link>
      </Tooltip>
    );
  },
  
  lightT: (descToI18n) => {
    return (
      <Tooltip light content={CsI18n.t(descToI18n)}>
        <Link>
          <Icon source={CircleInformationMajorFilled} color="inkLighter" />
        </Link>
      </Tooltip>
    );
  }
}

export default TooltipHelper;